module.exports = __webpack_public_path__ + "static/media/Kapitell.98244e59.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Kapitell.JPG
// module id = 759
// module chunks = 0